export const INPUT_TYPES = {
	NUMBER: 'number',
	DATE: 'date',
	TEXT: 'text',
	TEXT_AREA: 'textarea'
};
